import { ajax } from '@/api/ajax';
import type {
  TArticleDetailReq,
  TArticleDetailRsp,
  TBookMapTopicExistsRsp,
  TBookMapTopicRefDetailReq,
  TManualListReq,
  TManualListRsp
} from './type';

// 查询
export function getArticleDetail(data: TArticleDetailReq) {
  return ajax<TArticleDetailRsp>({
    url: '/api/node-server/xp-ass-tis-cn-boot/portal/bookmap/topic/info',
    method: 'post',
    data
  });
}

export function getManualList(data: TManualListReq) {
  return ajax<TManualListRsp>({
    url: '/api/node-server/xp-ass-tis-cn-boot/portal/bookmap/list',
    method: 'post',
    data: data
  });
}

export function isTopicExistsUsingPost(data: TBookMapTopicRefDetailReq) {
  return ajax<TBookMapTopicExistsRsp>({
    url: '/api/node-server/xp-ass-tis-cn-boot/portal/bookmap/topic/ref/exists',
    method: 'post',
    data: data
  });
}
